module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa phiếu chi",
      "breadcrumbs": [{
        title: 'Quản lý phiếu chi',
        route: {
          name: 'invoice'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all margin-top"
  }, [_c('el-form', {
    ref: "edit-invoice-form",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localInvoice,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Tìm kiếm người nhận",
      "prop": "client_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên, sđt...",
      "remote-method": _vm.selectReceiver,
      "loading": _vm.fetchReceiver
    },
    on: {
      "change": _vm.selectSuggettionReceiver
    },
    model: {
      value: (_vm.suggettionReceiver),
      callback: function($$v) {
        _vm.suggettionReceiver = $$v
      },
      expression: "suggettionReceiver"
    }
  }, _vm._l((_vm.listReceiver), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm vận đơn"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "disabled": !_vm.localInvoice.client_id,
      "placeholder": "Nhập mã,...",
      "remote-method": _vm.selectShipment,
      "loading": _vm.fetchShipment
    },
    on: {
      "change": _vm.selectSuggettionShipment
    },
    model: {
      value: (_vm.suggettionShipment),
      callback: function($$v) {
        _vm.suggettionShipment = $$v
      },
      expression: "suggettionShipment"
    }
  }, _vm._l((_vm.listShipment), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left shipment-code-display"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right shipment-code-display"
    }, [_vm._v(_vm._s(item.code))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lý do",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Lý do"
    },
    model: {
      value: (_vm.localInvoice.description),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "description", $$v)
      },
      expression: "localInvoice.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Loại phiếu",
      "prop": "kind"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Loại phiếu"
    },
    model: {
      value: (_vm.localInvoice.kind),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "kind", $$v)
      },
      expression: "localInvoice.kind"
    }
  }, _vm._l((_vm.invoiceHelpers.kinds), function(item, key, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": key,
        "label": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tổng tiền phải trả cho shop",
      "prop": "total_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng tiền phải trả cho shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('total_amount')
      },
      "blur": function($event) {
        return _vm.addZero('total_amount')
      }
    },
    model: {
      value: (_vm.localInvoice.total_amount),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "total_amount", $$v)
      },
      expression: "localInvoice.total_amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.total_amount)))])])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tiền cộng vào tài khoản shop",
      "prop": "debt"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiền cộng vào tài khoản shop"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('debt')
      },
      "blur": function($event) {
        return _vm.addZero('debt')
      }
    },
    model: {
      value: (_vm.localInvoice.debt),
      callback: function($$v) {
        _vm.$set(_vm.localInvoice, "debt", $$v)
      },
      expression: "localInvoice.debt"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localInvoice.debt)))])])], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(Object.keys(_vm.suggettionReceiver).length) ? _c('h3', [_vm._v("Thông tin người nhận")]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.suggettionReceiver).length) ? _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.name) + "    "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.phone) + "    "), _c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.suggettionReceiver.email))]) : _vm._e(), _vm._v(" "), (_vm.shipmentAdded.length) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.shipmentAdded
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Mã",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 1353483373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người nhận"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.receiver.data.phone))])]
      }
    }], null, false, 1336654758)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người gửi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('i', {
          staticClass: "fa fa-user"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.name))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-phone"
        }), _vm._v(" " + _vm._s(scope.row.picker.data.phone))])]
      }
    }], null, false, 438074374)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí COD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.id)))])]
      }
    }], null, false, 2465153771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payer_txt))])]
      }
    }], null, false, 52296414)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Xóa"
          }
        }, [_c('a', {
          staticClass: "text-red padding-all display-inline-block cursor-pointer",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeShipment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])])]
      }
    }], null, false, 1101567570)
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea7c7e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/EditInvoice.vue
// module id = 644
// module chunks = 1